import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  Input,
  OnDestroy,
  OnInit,
  Renderer2,
  inject
} from '@angular/core';
import { Router } from '@angular/router';
import { FormV3 } from '@bepatient/common';
import {
  CorePageModuleIDs,
  CoreRouterActionNavigateRoot,
  CoreRouterActionNavigateToPageModule,
  CoreRouterNavigationIntent
} from '@bepatient/core';
import { getAccessibleTextColor } from '@bepatient/shared';
import { MenuController, NavController, Platform } from '@ionic/angular';
import { Store } from '@ngrx/store';
import { Subscription } from 'rxjs';
import { ThemeService } from './../services/theme.service';

@Component({
  selector: 'bepatient-dynamic-header',
  templateUrl: './dynamic-header.component.html',
  styleUrls: ['./dynamic-header.component.scss'],
  standalone: false
})
export class DynamicHeaderComponent implements OnInit, OnDestroy {
  private element = inject(ElementRef);
  private renderer = inject(Renderer2);
  private navController = inject(NavController);
  private menuController = inject(MenuController);
  private store$ = inject<Store<any>>(Store);
  private router = inject(Router);
  private themeService = inject(ThemeService);
  private cdr = inject(ChangeDetectorRef);
  private platform = inject(Platform);

  @Input() icon = '';
  @Input() title = '';
  @Input() image = '';
  @Input() subtitle = '';
  @Input() formForActivities: FormV3;
  @Input() navigationAuthorize: () => Promise<boolean>;
  @Input() navigationAuthorizeCtx: any;
  @Input() hideSelector = false;

  @Input() close: boolean;
  @Input() isFactsheet: boolean;

  contrast = '#2e2e2e';
  imageOpacity = 1;
  displayActivity = true;
  enableSkeleton: boolean;

  private _color = '#fafafa';
  private themeSub?: Subscription;

  @Input() set color(v: string) {
    this._color = v || '#fafafa';
    // Background keeps the raw study color; only the contrast text is adjusted.
    this.renderer.setStyle(this.element.nativeElement, 'background', v);
    this.applyContrast();
  }

  get color(): string {
    return this._color;
  }

  get isWebview(): boolean {
    return !(this.platform.is('android') || this.platform.is('ios'));
  }

  /**
   * Derives the contrast text color from the raw study color via the canonical
   * WCAG-AA utility (docs/adr/0001-contrast-utility-consolidation.md).
   */
  private applyContrast(): void {
    this.contrast = getAccessibleTextColor(this._color);
  }

  ngOnInit(): void {
    // Re-derive the contrast text color on every theme / high-contrast toggle
    // so it stays legible without a page reload.
    this.themeSub = this.themeService.themeChange$.subscribe(() => {
      this.applyContrast();
      this.cdr.markForCheck();
    });

    /**
     *  For now, `my-account-*` page only uses bepatient skeleton component
     * */
    this.router.url.includes('/my-account-')
      ? (this.enableSkeleton = true)
      : (this.enableSkeleton = false);
  }

  ngOnDestroy(): void {
    this.themeSub?.unsubscribe();
  }

  navigationButtonClick(isBack: boolean): void {
    (
      (this.navigationAuthorize &&
        this.navigationAuthorize.call(this.navigationAuthorizeCtx || this)) ||
      Promise.resolve(true)
    ).then(authorization => {
      if (authorization) {
        if (isBack) {
          this.navController.back();
        } else {
          this.store$.dispatch(
            new CoreRouterActionNavigateToPageModule({
              id: CorePageModuleIDs.MENU,
              pageIndex: 0,
              intent: CoreRouterNavigationIntent.FORWARD
            })
          );
        }
      }
    });
  }

  gotoTimeline(goto: boolean): void {
    if (goto) {
      this.store$.dispatch(
        new CoreRouterActionNavigateRoot({ url: 'timeline' })
      );
    }
  }
}
